import { render, staticRenderFns } from "./senha-recuperar.vue?vue&type=template&id=344451c4"
import script from "./senha-recuperar.vue?vue&type=script&lang=js"
export * from "./senha-recuperar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports